import { Box, Flex, Pagination, Tag } from '@cowsquare/design';
import * as R from 'ramda';
import React from 'react';
import styled from 'styled-components';
import navigateWithQuery from '../utils/navigate';
import MedicalCard from './MedicalCard';

const PAGE_SIZE = 20;

const CardBox = styled(Box).attrs({
  width: [1, 1 / 3],
  mb: 5,
  px: 4,
  pb: 5,
})``;

const MedicalCardList = ({
  height,
  cardData,
  defaultCover,
  total,
  query,
  uri,
  page,
  onPageChange,
  options = R.identity,
  ...restProps
}) => {
  return (
    <Box mt={5} mx={-4}>
      <Flex flexWrap="wrap">
        {R.map(item => {
          const optionProps = options(item);
          return (
            <CardBox key={item.id}>
              <MedicalCard
                height={height}
                linkUrl={`${uri}/${R.propOr('', 'id', item)}`}
                coverUrl={R.pathOr(defaultCover, ['cover', 'link'], item)}
                cardInfoData={[
                  { key: item.phone, icon_name: 'phone', text: item.phone },
                  {
                    key: item.address,
                    icon_name: 'location',
                    text: item.address,
                  },
                ].filter(info => info.text)}
                title={R.propOr('', 'name', item)}
                tags={R.pipe(
                  R.propOr([], 'tags'),
                  R.map(R.path(['tag', 'name'])),
                  R.map(tag => (
                    <Tag
                      key={tag}
                      onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        navigateWithQuery(uri, { ...query, tag });
                      }}
                    >
                      {tag}
                    </Tag>
                  ))
                )(item)}
                {...optionProps}
                {...restProps}
              />
            </CardBox>
          );
        }, cardData)}
      </Flex>
      {total > PAGE_SIZE && (
        <Flex justifyContent="center">
          <Box mt={7} mb={8}>
            <Pagination current={page} pageSize={PAGE_SIZE} total={total} onChange={onPageChange} />
          </Box>
        </Flex>
      )}
    </Box>
  );
};

export default MedicalCardList;
